import { z } from 'zod/v3';
import {
  errorMap,
  transformNull,
  zCodeWithoutLeadingNumberOrEmpty,
} from '../../../../common/utils';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmSourceValidFormDataSchema.translations.json';
import { AlgorithmSourceDimensionFormDataSchema } from './AlgorithmSourceFormDataSchema';

const { addTranslations, t } = i18nNsFactory(
  'algorithm-source-valid-form-data-schema',
);
addTranslations(translations);

export const AlgorithmSourceValidFormDataSchema = z.object({
  id: transformNull(z.number().readonly(), -1),
  sourceId: z.string(errorMap(() => t('validation.sourceId.required'))).min(1),
  numberOfPreviousPeriod: z.number().optional(),
  alias: zCodeWithoutLeadingNumberOrEmpty,
  sourceType: transformNull<string>(z.string(), '').optional(),
  sourceCode: z.string(),
  sourceName: z.string(),
  domainId: z.number().nullish(),
  dataObjectCode: z.string().nullish(),
  dimensions: AlgorithmSourceDimensionFormDataSchema.array(),
});
